<template>
  <v-container ma-0 pa-0 fluid>
    <v-navigation-drawer v-model="drawer" fixed app clipped right disable-resize-watcher disable-route-watcher>
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template #activator="{on}">
              <v-btn flat color="success" icon @click="drawer=!drawer" v-on="on">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
            <span>关闭</span>
          </v-tooltip>\
        </v-card-actions>
        <v-card-title primary-title class="title">
          请选择要隐藏的字段
        </v-card-title>
        <v-container grid-list-xs fluid full-width>
          <v-layout row wrap align-center>
            <v-flex xs6 v-for="(item, index) in headers" :key="index">
              <v-switch color="error" :label="item.text" v-model="item.hide">
              </v-switch>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-navigation-drawer>
    <vuetify-table :props="tableProps">
      <template v-slot:[getTemplateName(item)]="{props}" v-for="(item, index) in headers">
        <slot :name="'table-cell-'+item.value" :props="props.item">
        </slot>
      </template>
      <template #table-bottom='{props,syncProps}'>
        <slot name="table-bottom" :props="props" syncProps="syncProps"></slot>
      </template>
    </vuetify-table>
  </v-container>
</template>

<style scoped lang="less" src="./style.less">

</style>


<script>
  import GhTable from "./ghTable.ts";
  export default GhTable;
</script>